import styled from 'styled-components'

const TimelineContainer = styled.div`
  display: flow-root;
`

export default TimelineContainer
